export default __webpack_public_path__ + "static/media/export.25c4924b.svg";